import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { Dashboard } from 'types'

import { unscopedApiClient } from '../../unscopedApiClient'
import { getCerebroHeaders } from '../headers'

export const getPrintableDashboard = (
    dashboardId: string,
    options: AxiosRequestConfig = {}
): Promise<AxiosResponse<Dashboard>> => {
    return unscopedApiClient.get(`api/dashboard/${dashboardId}/`, {
        headers: getCerebroHeaders(options.headers),
    })
}
